import { modDashboardDemoData } from 'open-modules/zdf/component/moddashboard/__demos__/moddashboard-demo.data';
import { component, demoFile, feature } from 'system/demo';

demoFile('open-modules/zdf/feature/moddashboard-settings');

const globals = { initialized: true };

const modulePublic = {
    question: modDashboardDemoData.modulePublicQuestion,
    moderation: {
        queue: {
            ...modDashboardDemoData.modTaskQueues.thread1,
            ...modDashboardDemoData.modTaskQueues.thread2,
        },
        queue_filtered: {
            awaiting_decision: {
                ...modDashboardDemoData.modTaskSubQueues.thread1.awaiting_decision,
                ...modDashboardDemoData.modTaskSubQueues.thread2.awaiting_decision,
            },
            human_approved: {
                ...modDashboardDemoData.modTaskSubQueues.thread1.human_approved,
                ...modDashboardDemoData.modTaskSubQueues.thread2.human_approved,
            },
            auto_approved: {
                ...modDashboardDemoData.modTaskSubQueues.thread1.auto_approved,
                ...modDashboardDemoData.modTaskSubQueues.thread2.auto_approved,
            },
            rejected: {
                ...modDashboardDemoData.modTaskSubQueues.thread1.rejected,
                ...modDashboardDemoData.modTaskSubQueues.thread2.rejected,
            },
        },
        thread_queue_count: {
            ...modDashboardDemoData.threadQueueCounts,
        },
    },
};

feature('moddashboardsettings', {
    structureKey: 'moddashboard',
    state: {
        roles: ['Moderator'],
        globals: { globals },
        modulePublic: modulePublic,
        serverCall: {},
    },
});
